// src/hooks/useSingleDeviceSession.js
import { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";

export function useSingleDeviceSession() {
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    let unsubUser = null;

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        // 🔒 Si no hay usuario → limpiar listener
        if (unsubUser) {
          unsubUser();
          unsubUser = null;
        }
        return;
      }

      const userRef = doc(db, "usuarios", currentUser.uid);

      unsubUser = onSnapshot(
        userRef,
        (snapshot) => {
          if (!snapshot.exists()) return;

          const data = snapshot.data();
          const deviceIdLocal = localStorage.getItem("deviceId");
                console.log("👀 Listener detectó cambios:", { data, deviceIdLocal });

          // 🚨 Reglas de sesión única
          if (
            data?.activo === true &&         // Usuario marcado como activo
            data?.deviceId &&                // Tiene deviceId en Firestore
            deviceIdLocal &&                 // Hay deviceId en localStorage
            data.deviceId !== deviceIdLocal  // No coinciden
          ) {
            console.warn("🚫 Sesión en otro dispositivo detectada → logout forzado");

            setError("Tu cuenta está activa en otro dispositivo.");
            setShowModal(true);

            // 🔒 Forzar logout en este dispositivo
            signOut(auth).catch((err) =>
              console.error("❌ Error al cerrar sesión:", err)
            );
          }
        },
        (err) => {
          console.error("❌ Error en listener de sesión única:", err);
        }
      );
    });

    // 🔑 Cleanup global
    return () => {
      unsubscribe();
      if (unsubUser) unsubUser();
    };
  }, []);

  return { error, showModal, setShowModal };
}
